import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom';
import App from "App";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    {/* <IdleTimeOutHandler> */}
      <App />
    {/* </IdleTimeOutHandler> */}
  </BrowserRouter>
);


// const container = document.getElementById("root");
// // const root = ReactDOMClient.createRoot(container);

// ReactDOM.render(
//   <BrowserRouter>
//     <IdleTimeOutHandler />
//     <App />
//   </BrowserRouter>,
//   container
// );
